import { render } from "./App.vue?vue&type=template&id=4fccf80d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4fccf80d&lang=scss"

import exportComponent from "/root/workspace/xxzx-website-county_fx0Z/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__